module.exports = function (c, d, f, g) {
  var h = {
    _html: {
      settings: {
        input: {
          generic: function (j, k, l, m) {
            return (
              "<input type='" +
              j +
              "' name='" +
              j +
              "' id='slid_" +
              k +
              "' class='inputGrey2' placeholder='" +
              m +
              "'\n                       value='" +
              l.val +
              "' oninput='setSetting(\"" +
              k +
              "\", this.value)'/>"
            );
          },
          color: function (j, k) {
            return (
              "<input type='color' name='color' id='slid_" +
              j +
              "' style='float:right' value='" +
              k.val +
              "'\n                       oninput='setSetting(\"" +
              j +
              "\", this.value)'/>"
            );
          },
          switch: function (j, k) {
            return (
              "<label class='switch' style='margin-left:10px'><input type='checkbox' onclick='setSetting(\"" +
              j +
              "\", this.checked)'\n                       " +
              (k.val ? "checked" : "") +
              "><span class='slider'></span></label>"
            );
          },
          slider: function (j, k, l = "") {
            return (
              "<input type='number' class='sliderVal' id='slid_input_" +
              j +
              "' min='" +
              k.min +
              "' max='" +
              k.max +
              "'\n                       value='" +
              k.val +
              "' onkeypress='return delayExecute(\"" +
              j +
              '", this, ' +
              k.delay +
              ")' style='margin-right:0px;border-width:0px'/>\n                       <div class='slidecontainer' style='" +
              l +
              "'><input type='range' id='slid_" +
              j +
              "' min='" +
              k.min +
              "' max='" +
              k.max +
              "' step='" +
              k.step +
              "'\n                       value='" +
              k.val +
              "' class='sliderM' oninput='setSetting(\"" +
              j +
              "\", this.value)'></div>"
            );
          },
          select: function (j, k, l) {
            return (
              "<select onchange='setSetting(\"" +
              j +
              "\", this.value)' class='inputGrey2'>\n                       " +
              Object.keys(l).map(
                (m) =>
                  "<option value='" +
                  m +
                  "' " +
                  (m == k.val ? "selected" : "") +
                  ">" +
                  l[m] +
                  "</option>",
              ) +
              "</select>"
            );
          },
        },
      },
    },
    action: function (j, k) {
      let l = h;
      j.forEach((m) => (l = l[m]));
      switch (l.type) {
        case "dropper":
          let m = k.parentElement.children[1];
          let o = h.clanwars.droppers.elem;
          if (o) {
            o.style.transform = null;
            o.classList.toggle("bounce", false);
          }
          m.style.transform = "scale(1.0) translateY(-41px)";
          m.classList.toggle("bounce", true);
          h.clanwars.droppers.elem = m;
          if (l.onclick) {
            l.onclick();
          }
          break;
        case "button":
          if (l.onclick) {
            l.onclick();
          }
      }
    },
    _build: function (j) {
      let k = h;
      j.forEach((l) => (k = k[l]));
      return Object.keys(k)
        .map((l) => {
          let m = k[l];
          let o =
            "GUI.action(" +
            JSON.stringify([...j, l]).replace(/\"/g, "'") +
            ", this)";
          switch (m.type) {
            case "dropper":
              return (
                '<div class="dropper" style="transform: translate(' +
                m.pos[0] +
                "px, " +
                m.pos[1] +
                'px)">\n\t\t\t\t\t\t\t<div class="dropperPoint" onclick="' +
                o +
                '"></div>\n\t\t\t\t\t\t\t<div class="dropperArrow" onclick="' +
                o +
                "\"><div class='dropperArrowBod'>\n\t\t\t\t\t\t\t<div class=\"dropperText" +
                (m.color == "rgb" ? " rainbowText" : "") +
                '" style="color:' +
                (m.color ? m.color : "#fff") +
                ";" +
                (m.text ? "" : "height:25px;") +
                '">' +
                (m.text || "") +
                "</div>\n\t\t\t\t\t\t\t<i class='material-icons' style='color:white;font-size:30px;transform:translateY(-4px)'>tour</i>\n\t\t\t\t\t\t\t</div></div></div>"
              );
            case "button":
              return (
                '<div id="' +
                (m.id || "") +
                '" style="' +
                (m.style || "") +
                '" onclick="' +
                o +
                '">' +
                (m.html || "") +
                "</div>"
              );
            default:
              return "";
          }
        })
        .join("\n");
    },
    clanwars: {
      filter: {
        settings: {
          increment: 0.00001,
          min: 0.02,
          max: 0.03,
          counter: 0,
        },
        animation: function () {
          let j = h.clanwars.filter;
          j.settings.counter +=
            j.settings.increment / (j.settings.max - j.settings.min);
          let k =
            c.easeinout(j.settings.counter) *
              (j.settings.max - j.settings.min) +
            j.settings.min;
          j.elem.baseFrequencyX.baseVal = k;
          j.elem.baseFrequencyY.baseVal = k * 2;
          if (j.settings.counter > 1 || j.settings.counter < 0) {
            j.settings.increment *= -1;
          }
          requestAnimationFrame(j.animation);
        },
        init: function () {
          this.elem = document.getElementById("sea-filter");
          if (!this.setup) {
            this.setup = true;
            requestAnimationFrame(this.animation);
          }
        },
      },
      region: {
        deselect: function () {
          let j = h.clanwars.droppers.elem;
          if (j) {
            j.style.transform = null;
            j.classList.toggle("bounce", false);
          }
        },
        show: function (j, k) {
          let m;
          let p;
          let q;
          let u = f.skins.find(
            (x) =>
              x && x.limT && x.limT == "Clan Wars" && x.region && x.region == j,
          );
          let v = c.getPreview(u, f);
          let w =
            "<div class='regionCard'><div style='margin-bottom:10px;'><span class='regionTitle'>" +
            j +
            "</span><div style='float:right;color:rgba(0,0,0,0.3)'>Reward: <div class='rewItemIcon' style='background-image:url(&quot;" +
            v +
            "&quot;)' onclick='openSales(" +
            u.index +
            ")'></div><span class='regionKR'> <span style='color:rgba(0,0,0,0.3)'>+</span> " +
            c.commaNumber((k ? k.kr : 0) || 0) +
            "<span style='color:rgba(0,0,0,0.6)'> KR</span></span></div></div>";
          if (k && k.list && k.list.length) {
            k.list.forEach(function (x, y) {
              m =
                "<span style='color:rgba(0,0,0,0.3)'>Kills </span><span style='margin-right:10px'>" +
                (x.kills || 0).toLocaleString() +
                "</span>";
              p =
                "<span style='color:rgba(0,0,0,0.3);margin-right:5px'><img src='./img/soldier_0.png' width=30 height=30style='transform:translateY(1px);image-rendering:pixelated;'></span><span style='margin-right:10px'>" +
                (x.soldiers || 0).toLocaleString() +
                "</span>";
              q =
                "<span style='color:rgba(0,0,0,0.3);margin-right:5px'><img src='./img/soldier_1.png' width=30 height=30 style='transform:translateY(1px);image-rendering:pixelated;'></span><span>" +
                (x.kia || 0).toLocaleString() +
                "</span>";
              w +=
                "<div>" +
                (y + 1) +
                ". <a target='_blank' href='/social.html?p=clan&q=" +
                x.name +
                "' class='rName" +
                (x.color == "rgb" ? " rainbowText" : "") +
                "'style='color:" +
                (x.color ? x.color : "rgba(0,0,0,0.6)") +
                "'>[" +
                x.name +
                "]</a><span style='color:rgba(0,0,0,0.3)'> Clan</span><div style='float:right'>" +
                m +
                p +
                q +
                "</div></div>";
            });
          } else {
            w +=
              "<div class='rEmpty'>No Clans currently occupying this Region</div>";
          }
          w += "</div>";
          clanwarsInfo.innerHTML = w;
        },
      },
      droppers: {
        show: function (j) {
          let k;
          this.blueprint = {};
          g.clanRegions.forEach((l, m) => {
            k =
              j && j[m] && j[m].list[0] && j[m].list[0].name
                ? j[m].list[0]
                : null;
            this.blueprint[m] = {
              type: "dropper",
              pos: l.pos,
              color: k ? k.color : null,
              text: k ? "[" + j[m].list[0].name + "]" : null,
              onclick: function () {
                h.clanwars.region.show(l.name, j[m]);
              },
            };
          });
          dropperHolder.innerHTML = h._build([
            "clanwars",
            "droppers",
            "blueprint",
          ]);
        },
      },
      help: {
        show: function (j) {
          let k = this;
          this.blueprint = {
            icon: {
              type: "button",
              id: "clanwarsHelpIcon",
              html: "<div>?</div>",
              onclick: function () {
                let m = clanwarsHelpWin.style.display != "none";
                clanwarsHelpWin.style.display = m ? "none" : null;
                clanwarsHelpVig.style.display = m ? "none" : null;
              },
            },
            vig: {
              type: "button",
              id: "clanwarsHelpVig",
              style: "display:none",
              onclick: function () {
                k.blueprint.icon.onclick();
              },
            },
          };
          var l =
            h._build(["clanwars", "help", "blueprint"]) +
            "<div id='clanwarsHelpWin' style='display:none'><div class='cwHelpHed'>Welcome to Clan Wars</div><div class='cwHelpBod'>Clan Leaders can assign up to 30 Clan Members to different Regions. Once a player is assigned to a Region,\n\t\t\t\t\t\tany kills they get in a pub match will count toward the clans overall kills in that Region.\n\t\t\t\t\t\t<div style='height:16px'></div>If a player runs out of lives (by dying in Pub Matches),\n\t\t\t\t\t\ttheir contract will end and the clan leader has to replace\n\t\t\t\t\t\tthem with another player until the next Clan War.<div style='height:16px'></div>At the end of the\n\t\t\t\t\t\tWar Period, the Clan with the most kills in a specific Region will win all the KR available in that Region.\n\t\t\t\t\t\tThe Clans with the most Kills globally, will also receive special clan tag colors:\n\t\t\t\t\t\t<div class='clanRewH' style='margin-top:20px'># 1 Clan <span style='float:right;' class='rainbowText'>[CLAN]</span></div>\n\t\t\t\t\t\t<div class='clanRewH' style='margin-top:20px'># 2-5 Clan <span style='float:right;color:#eb3437'>[CLAN]</span></div>\n\t\t\t\t\t\t<div class='clanRewH' style='margin-top:20px'># 6-15 Clan <span style='float:right;color:#FBC02D'>[CLAN]</span></div>\n\t\t\t\t\t\t<div class='clanRewH' style='margin-top:20px'># 16-25 Clan <span style='float:right;color:#e834eb'>[CLAN]</span></div>\n\t\t\t\t\t\t<div class='clanRewH' style='margin-top:20px'># 26-50 Clan <span style='float:right;color:#349ceb'>[CLAN]</span></div>\n\t\t\t\t\t\t<div style='height:20px'></div>Remember to have fun and to follow the\n\t\t\t\t\t\t<a style='color:#00a6ff' target='_blank' href='./docs/clan.txt'>Rules</a></div></div>";
          clanwarsHelp.innerHTML = l;
          if (j) {
            setTimeout(function () {
              k.blueprint.icon.onclick();
            });
          }
        },
      },
      buttons: {
        show: function (j, k) {
          var l = j.map((m) => m.list).reduce((m, o) => [...m, ...o]);
          this.blueprint = {
            leader: {
              type: "button",
              id: "clanwarsLeaderIcon",
              html: "<div><i class='material-icons' style='color:white'>emoji_events</i></div>",
              onclick: function () {
                h.clanwars.region.deselect();
                let m;
                let p =
                  "<div class='regionCard'><div style='margin-bottom:10px;'><span class='regionTitle'>Global Leaders</span></div>";
                if (l) {
                  var q = {};
                  l.forEach(function (z) {
                    if (q[z.name]) {
                      q[z.name].kills += z.kills;
                      q[z.name].soldiers += z.soldiers;
                      q[z.name].kia += z.kia;
                    } else {
                      q[z.name] = {
                        name: z.name,
                        color: z.color,
                        kills: z.kills,
                        soldiers: z.soldiers,
                        kia: z.kia,
                      };
                    }
                  });
                  var u = [];
                  for (var v in q) {
                    if (q.hasOwnProperty(v)) {
                      u.push(q[v]);
                    }
                  }
                  var w = 1;
                  u = u.sort((z, A) => A.kills - z.kills);
                  for (var x = 0; x < u.length; ++x) {
                    m =
                      "<span style='color:rgba(0,0,0,0.3);'>Kills </span><span style='margin-right:12px'>" +
                      (u[x].kills || 0).toLocaleString() +
                      "</span>";
                    var y = u[x].color || "rgba(0,0,0,0.6)";
                    p +=
                      "<div>" +
                      w +
                      ". <a target='_blank' href='/social.html?p=clan&q=" +
                      u[x].name +
                      "' class='rName" +
                      (y == "rgb" ? " rainbowText" : "") +
                      "'style='color:" +
                      y +
                      "'>[" +
                      u[x].name +
                      "]</a><span style='color:rgba(0,0,0,0.3)'> Clan</span><div style='float:right'>" +
                      m +
                      "<span style='color:rgba(0,0,0,0.3);margin-right:5px'><img src='./img/soldier_0.png' width=30 height=30style='transform:translateY(1px);image-rendering:pixelated;'></span><span>" +
                      (u[x].soldiers || 0).toLocaleString() +
                      "</span><span style='color:rgba(0,0,0,0.3);margin-right:5px;margin-left:10px'><img src='./img/soldier_1.png' width=30 height=30 style='transform:translateY(1px);image-rendering:pixelated;'></span><span>" +
                      (u[x].kia || 0).toLocaleString() +
                      "</span></div></div>";
                    w++;
                  }
                } else {
                  p += "<div class='rEmpty'>No Clans Found</div>";
                }
                p += "</div>";
                clanwarsInfo.innerHTML = p;
              },
            },
            kills: {
              type: "button",
              id: "clanwarsPlayerKillsIcon",
              html: "<img src='./img/soldier_0.png' width='20' height='20' style='image-rendering:pixelated;margin:auto;position:absolute;left:0;right:0;top:0;bottom:0'>",
              onclick: function () {
                h.clanwars.region.deselect();
                let m =
                  "<div class='regionCard'><div style='margin-bottom:10px;'><span class='regionTitle'>Top Soldiers</span></div>";
                for (var p = 0; p < k.length; ++p) {
                  var q =
                    "<span style='color:rgba(0,0,0,0.3);'>Kills </span><span style='margin-right:15px'>" +
                    (k[p].k || 0).toLocaleString() +
                    "</span>";
                  var u =
                    g.clanWarLives -
                    Math.min(parseInt(k[p].d || 0), g.clanWarLives);
                  var v = d.getClanCol(
                    k[p].c,
                    k[p].cr,
                    "color:rgba(0,0,0,0.6)",
                  );
                  var w =
                    "<span style='color:rgba(0,0,0,0.3);'>Lives </span><span style='margin-right:5px'>" +
                    u.toLocaleString() +
                    "</span>";
                  m +=
                    "<div " +
                    (k[p].d >= g.clanWarLives
                      ? "style='background-color:rgba(255,0,0,0.1)'"
                      : "") +
                    "><div style='width:5px;display:inline-block'></div>" +
                    (p + 1) +
                    ". <a target='_blank' href='/social.html?p=profile&q=" +
                    k[p].p +
                    "'>" +
                    k[p].p +
                    "</a> <a target='_blank' href='/social.html?p=clan&q=" +
                    k[p].c +
                    "' class='rName" +
                    (v == "rgb" ? " rainbowText" : "") +
                    "' style='" +
                    v +
                    "'>[" +
                    k[p].c +
                    "]</a><span style='float:right'>" +
                    q +
                    w +
                    "</span></div>";
                }
                m += "</div>";
                clanwarsInfo.innerHTML = m;
              },
            },
          };
          clanwarsButtons.innerHTML += h._build([
            "clanwars",
            "buttons",
            "blueprint",
          ]);
        },
      },
      show: function (j, k) {
        j = j || [];
        k = k || [];
        this.filter.init();
        this.help.show();
        this.buttons.show(j, k);
        this.droppers.show(j);
        clanwarsButtons.children[0].onclick();
      },
    },
  };
  window.GUI = c.removePrivateKeys(h);
  return h;
};
